import { render } from "./CreateExpenseHead.vue?vue&type=template&id=2b8de5de&scoped=true"
import script from "./CreateExpenseHead.vue?vue&type=script&lang=js"
export * from "./CreateExpenseHead.vue?vue&type=script&lang=js"

import "./CreateExpenseHead.vue?vue&type=style&index=0&id=2b8de5de&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8de5de"]])

export default __exports__